<template>
  <div id="app">
    
    <div class="intec-template">
      <div class="intec-template-layout intec-content-wrap"> 
        <Header></Header>
        <Main></Main>
        <Footer></Footer>
      </div>
    </div>
    
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Main from '@/components/Main.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Header,
    Main,
    Footer
  }
}
</script>

<style lang="sass">
*,
*::before,
*::after
  box-sizing: border-box

html, body
  height: 100%
  margin: 0
  padding: 0

html
  font-size: 14px
  font-family: "Montserrat", sans-serif
  line-height: 1.42857143
  color: #2d2d2d

body
  font-size: inherit
  font-family: inherit
  line-height: inherit
  color: inherit

.intec-template-layout
  display: flex
  flex-direction: column
  height: 100%
  min-height: 100vh

.intec-template
  display: block
  height: 100%
  position: relative
.intec-content-wrap
  min-width: 320px

.m
  flex: 1

a
  text-decoration: none
  color: #012786
img, svg
  vertical-align: bottom

.container
  max-width: 1384px
  min-width: 320px
  margin: 0 auto
  padding-left: 20px
  padding-right: 20px

input
  font: inherit
  border: none
  &:active, &:hover, &:focus 
    outline: 0
    outline-offset: 0
.logo
  &__img
    width: 220px

.button
  border: 1px solid #8193ba
  width: 140px
  height: 40px
  text-align: center
  font-family: inherit
  font-size: 11px
  padding: 0
  color: #202c45
  cursor: pointer
  border-radius: 5px
  box-shadow: 0 8px 15px rgba(129, 147, 186, 0.26)
  transition: .5s
  &:hover
    background-color: #8193ba
    color: #fff
  &:disabled
    display: none

.docs-search-form
  &__button
    padding: 5px 15px
</style>
